import React from 'react'

class Logs extends React.Component {
  render () {
    return (
      <div>Logs</div>
    )
  }
}

export default Logs


// WEBPACK FOOTER //
// ./src/views/logs/Logs.js